var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-1 z-0 flex flex-col bg-gray-100"},[_c('main',{staticClass:"flex-1 z-0"},[_c('div',{staticClass:"mx-auto p-4",class:[
        { container: _vm.type == 'center', 'w-full': _vm.type == 'full' },
        _vm.compClass
      ]},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }